import { render, staticRenderFns } from "./CalculatorWidget.vue?vue&type=template&id=4d9654b0&"
import script from "./CalculatorWidget.vue?vue&type=script&lang=js&"
export * from "./CalculatorWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports